'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React$cloneElement = require('react');

var _React$cloneElement2 = _interopRequireDefault(_React$cloneElement);

var _Interpolate = require('./Interpolate');

var _Interpolate2 = _interopRequireDefault(_Interpolate);

var _BootstrapMixin = require('./BootstrapMixin');

var _BootstrapMixin2 = _interopRequireDefault(_BootstrapMixin);

var _classNames = require('classnames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ValidComponentChildren = require('./utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var ProgressBar = _React$cloneElement2['default'].createClass({
  displayName: 'ProgressBar',

  propTypes: {
    min: _React$cloneElement2['default'].PropTypes.number,
    now: _React$cloneElement2['default'].PropTypes.number,
    max: _React$cloneElement2['default'].PropTypes.number,
    label: _React$cloneElement2['default'].PropTypes.node,
    srOnly: _React$cloneElement2['default'].PropTypes.bool,
    striped: _React$cloneElement2['default'].PropTypes.bool,
    active: _React$cloneElement2['default'].PropTypes.bool
  },

  mixins: [_BootstrapMixin2['default']],

  getDefaultProps: function getDefaultProps() {
    return {
      bsClass: 'progress-bar',
      min: 0,
      max: 100
    };
  },

  getPercentage: function getPercentage(now, min, max) {
    var roundPrecision = 1000;
    return Math.round((now - min) / (max - min) * 100 * roundPrecision) / roundPrecision;
  },

  render: function render() {
    var classes = {
      progress: true
    };

    if (this.props.active) {
      classes['progress-striped'] = true;
      classes.active = true;
    } else if (this.props.striped) {
      classes['progress-striped'] = true;
    }

    if (!_ValidComponentChildren2['default'].hasValidComponent(this.props.children)) {
      if (!this.props.isChild) {
        return _React$cloneElement2['default'].createElement(
          'div',
          _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
          this.renderProgressBar()
        );
      } else {
        return this.renderProgressBar();
      }
    } else {
      return _React$cloneElement2['default'].createElement(
        'div',
        _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
        _ValidComponentChildren2['default'].map(this.props.children, this.renderChildBar)
      );
    }
  },

  renderChildBar: function renderChildBar(child, index) {
    return _React$cloneElement.cloneElement(child, {
      isChild: true,
      key: child.key ? child.key : index
    });
  },

  renderProgressBar: function renderProgressBar() {
    var percentage = this.getPercentage(this.props.now, this.props.min, this.props.max);

    var label = undefined;

    if (typeof this.props.label === 'string') {
      label = this.renderLabel(percentage);
    } else if (this.props.label) {
      label = this.props.label;
    }

    if (this.props.srOnly) {
      label = this.renderScreenReaderOnlyLabel(label);
    }

    var classes = this.getBsClassSet();

    return _React$cloneElement2['default'].createElement(
      'div',
      _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes), role: 'progressbar',
        style: { width: percentage + '%' },
        'aria-valuenow': this.props.now,
        'aria-valuemin': this.props.min,
        'aria-valuemax': this.props.max }),
      label
    );
  },

  renderLabel: function renderLabel(percentage) {
    var InterpolateClass = this.props.interpolateClass || _Interpolate2['default'];

    return _React$cloneElement2['default'].createElement(
      InterpolateClass,
      {
        now: this.props.now,
        min: this.props.min,
        max: this.props.max,
        percent: percentage,
        bsStyle: this.props.bsStyle },
      this.props.label
    );
  },

  renderScreenReaderOnlyLabel: function renderScreenReaderOnlyLabel(label) {
    return _React$cloneElement2['default'].createElement(
      'span',
      { className: 'sr-only' },
      label
    );
  }
});

exports['default'] = ProgressBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/ProgressBar.js
 ** module id = 238
 ** module chunks = 0
 **/